export const DEFAULT_CAPABILITIES = {
  crm_core_enabled: true,
  fyrefunnel_enabled: false,
  public_forms_enabled: false,
  max_public_forms: 0,
  widget_embed_enabled: false,
  mail_audit_enabled: true,
  email_tracking_allowed: false,
  marketing_consent_allowed: false,
  email_quota_monthly: null,
  automation_enabled: false,
};

export function normalizeCapabilities(capabilities) {
  return {
    ...DEFAULT_CAPABILITIES,
    ...(capabilities || {}),
  };
}

export function canUseFyreFunnel(capabilities) {
  const normalized = normalizeCapabilities(capabilities);
  return Boolean(normalized.crm_core_enabled && normalized.fyrefunnel_enabled);
}

export function canAccessPublicForms(capabilities) {
  const normalized = normalizeCapabilities(capabilities);
  return Boolean(canUseFyreFunnel(normalized) && normalized.public_forms_enabled);
}

export function canUsePublicForms(capabilities) {
  const normalized = normalizeCapabilities(capabilities);
  return Boolean(
    canAccessPublicForms(normalized)
      && Number(normalized.max_public_forms || 0) >= 1
  );
}

export function canSeeMailAudit(capabilities) {
  const normalized = normalizeCapabilities(capabilities);
  return Boolean(normalized.crm_core_enabled && normalized.mail_audit_enabled);
}
